module.exports = __webpack_public_path__ + "static/media/DSC_0146.29cd3443.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/events/DSC_0146.jpg
// module id = 593
// module chunks = 0